export const notificationSelectors = {
  defaultNotificationId: 'active-notification',
};
